var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.root)?_c('ComponentWithPropertiesInstance',{key:_vm.root.key,attrs:{"component":_vm.root}}):_c('LoadingView',{key:"promiseLoadingView"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }